import React, { useEffect } from 'react';

import { SignupUFOExperience } from '@/components/signup/utils/signup-ufo-logging';
import { UfoCustomTimingKey } from '@/components/signup/utils/ufo.types';

type UfoCustomTimingWrapperProps = {
	ufoEvent: SignupUFOExperience;
	ufoCustomTimingKey: UfoCustomTimingKey;
	children: React.ReactNode;
};

export const UfoCustomTimingWrapper = ({
	ufoEvent,
	ufoCustomTimingKey,
	children,
}: UfoCustomTimingWrapperProps) => {
	useEffect(() => {
		ufoEvent.startSubstep(ufoCustomTimingKey);

		return () => {
			ufoEvent.endSubstep(ufoCustomTimingKey);
		};
	}, []);

	return <>{children}</>;
};
